import React from 'react';
import PropTypes from 'prop-types';
import DocumentTemplateUtils from 'services/DocumentTemplateUtils';
import {
  BMISmartInput,
  FormulaSmartInput,
  CheckboxSumSmartInput,
  FeeSmartInput,
  GrowthChartSmartInput,
  MetricSmartInput,
  OtherSmartInput,
} from 'components/HealthRecords/Documents/DocumentTemplate/SmartInput';

const DocumentTemplateSmart = (props) => {
  let { field, editMode, pageWidth, pageHeight, selectEditElement, updateField, handleStop } =
    props;
  let { x_percent, y_percent, w_percent, h_percent, id, smartType } = field;

  let content;

  let addRnd = true;

  switch (smartType) {
    case 'growth_chart':
      content = <GrowthChartSmartInput {...props} />;
      break;
    case 'other':
      content = <OtherSmartInput {...props} />;
      break;
    case 'bmi':
      addRnd = false;
      content = <BMISmartInput {...props} />;
      break;
    case 'metric':
      addRnd = false;
      content = <MetricSmartInput {...props} />;
      break;
    case 'fees':
      addRnd = false;
      content = <FeeSmartInput {...props} />;
      break;
    case 'checkbox_sum':
      addRnd = false;
      content = <CheckboxSumSmartInput {...props} />;
      break;
    case 'formula':
      addRnd = false;
      content = <FormulaSmartInput {...props} />;
      break;
    default:
      content = (
        <div className="template-field" data-field-id={id}>
          Unknown Smart Input
        </div>
      );
  }

  if (addRnd) {
    let x = DocumentTemplateUtils.percentToPixel(x_percent, pageWidth);
    let y = DocumentTemplateUtils.percentToPixel(y_percent, pageHeight);
    let w = DocumentTemplateUtils.percentToPixel(w_percent, pageWidth);
    let h = DocumentTemplateUtils.percentToPixel(h_percent, pageHeight);
    return DocumentTemplateUtils.getRndElement(
      id,
      content,
      {
        x,
        y,
        w,
        h,
      },
      editMode,
      selectEditElement,
      handleStop,
      updateField,
    );
  } else {
    return content;
  }
};

DocumentTemplateSmart.propTypes = {
  field: PropTypes.object,
  selectedEditElement: PropTypes.string,
  editMode: PropTypes.bool,
  prefill: PropTypes.object,
  fieldValues: PropTypes.object,
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  selectEditElement: PropTypes.func,
  handleStop: PropTypes.func,
  onChange: PropTypes.func,
  updateField: PropTypes.func,
};

export default DocumentTemplateSmart;
